exports.install = function (Vue, options) {
	//get请求
	Vue.prototype.axiosget = function(url,value={})
	{
		value.token=this.getCookie(this.config.token);
		return this.axios.get(this.config.apiurl + url, {
			params: value
		})
		.then((response) => {
			if(response.data.code==0)
			{
				this.$message({ showClose: true, message: response.data.msg, type: 'warning'});
			}
			return response;
		})
		.catch((error) => {
			this.errorH(error.response.status);
			return error.response;
		})
	};
	//post请求
	Vue.prototype.axiospost = function(url,value={})
	{
		value.token=this.getCookie(this.config.token);
		return this.axios.post(this.config.apiurl + url, value)
		.then((response) => {
			if(response.data.code==1)
			{
				if(url!="/api/ysy/ptzStop")
				{
					if(url!="/api/ysy/ptzStart")
					{
						this.$message({ showClose: true, message: response.data.msg, type: 'success'});
					}
				}
			}
			else
			{
				this.$message({ showClose: true, message: response.data.msg, type: 'warning'});
			}
			return response;
		})
		.catch((error) => {
			this.errorH(error.response.status);
			return error.response;
		});
	};
	//错误信息
	Vue.prototype.geterror = function(value)
	{
		let errormeg={
			"400": "服务器不理解请求的语法",
			"401": "请求要求身份验证",
			"403": "服务器拒绝请求",
			"404": "服务器找不到请求的网页",
			"405": "禁用请求中指定的方法",
			"406": "无法使用请求的内容特性响应请求的网页",
			"407": "请求需要代理授权",
			"408": "服务器等候请求时发生超时",
			"409": "服务器在完成请求时发生冲突",
			"410": "请求的资源已永久删除",
			"411": "服务器不接受不含有效内容长度标头字段的请求",
			"412": "服务器未满足请求者在请求中设置的其中一个前提条件",
			"413": "服务器无法处理请求，因为请求实体过大，超出服务器的处理能力",
			"414": "请求的 URI（通常为网址）过长，服务器无法处理",
			"415": "请求的格式不受请求页面的支持",
			"416": "请求范围不符合要求",
			"417": "服务器未满足”期望”请求标头字段的要求",
			"500": "服务器遇到错误，无法完成请求",
			"501": "服务器不具备完成请求的功能",
			"502": "服务器作为网关或代理，从上游服务器收到无效响应",
			"503": "服务器目前无法使用",
			"504": "服务器作为网关或代理，但是没有及时从上游服务器收到请求",
			"505": "HTTP 版本不受支持"
		}
		if(errormeg[value]==null)
		{
			return "发生未知错误";
		}
		return errormeg[value];
	};
	//错误处理
	Vue.prototype.errorH = function(value)
	{
		if(value=="401")
		{
			// this.$message({
			// 	showClose: true,
			// 	message: "请登录！",
			// 	type: 'error',
			// 	center: true,
			// });
			this.$router.push('/login');
			return;
		}
		this.$message({ showClose: true, message: this.geterror(value), type: 'error'});
	};
	//json格式字符串转json对象
	Vue.prototype.MyJson = function(str)
	{
		if(this.isJson(str))
		{
			let json=JSON.parse(str);
			for(let key in json)
			{
				json[key]=this.MyJson(json[key]);
			}
			return json;
		}
		else
		{
			return str;
		}
	};
	//判断字符串json格式是否正确
	Vue.prototype.isJson = function(str)
	{
		if (typeof str === 'string') {
			try {
				let obj = JSON.parse(str);
				if (obj) {
					return true;
				} else {
					return false;
				}
			}
			catch (e) {
				return false;
			}
		}
		else
		{
			return false;
		}
	};
	//设置cookie信息，C_name:属性/value:值/expiredays:时间
	Vue.prototype.setCookie = function(c_name,value,expiredays)
	{
		var exdate=new Date()
		exdate.setDate(exdate.getDate()+expiredays)
		//设置cookie信息，以及过期时间
		document.cookie=c_name+ "=" +escape(value)+
		((expiredays==null) ? "" : ";expires="+exdate.toGMTString())+"; path=/";
	};
	//获取cookie信息
	Vue.prototype.getCookie=function(c_name)
	{
		if (document.cookie.length>0)
		{
			//获取“属性=”的位置
			var c_start=document.cookie.indexOf(c_name + "=")
			if (c_start!=-1)
			{ 
				//获取“属性=”的结束位置
				c_start=c_start + c_name.length+1 
				var c_end=document.cookie.indexOf(";",c_start)
				if (c_end==-1) c_end=document.cookie.length
				return unescape(document.cookie.substring(c_start,c_end))
			}
		}
		return "";
	};
	//时间戳转时间
	Vue.prototype.Totime=function(param) {
		let date = new Date(param * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
		if(!(date instanceof Date && !isNaN(date.valueOf())))
		{
			return "无效时间值！";
		}
		if(param=="")
		{
			return "暂无时间！";
		}
		let Y = date.getFullYear() + '-';
		let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
		let D = this.change(date.getDate()) + ' ';
		let h = this.change(date.getHours()) + ':';
		let m = this.change(date.getMinutes()) + ':';
		let s = this.change(date.getSeconds());
		return Y + M + D + h + m + s;
	};
	Vue.prototype.change=function(t) {
		if (t < 10) {
			return "0" + t;
		} else {
			return t;
		}
	};
	//加载省数据
	Vue.prototype.loadP=function(){
		this.getaddress()
		.then((response)=>{
			if(response.data.code==1)
			{
				let adr = response.data.data;
				for(let i=0;i<adr.length;i++)
				{
					adr[i].leaf = false;
				}
				this.$store.commit('address',adr);
			}
		});
	}
	//地址加载
	Vue.prototype.loadadr=function(value) {
		let va={
			province: value[0],
			city: value[1],
			county: value[2],
			town: value[3]
		};
		return this.getaddress(va)
		.then((response)=>{
			if(response.data.code==1)
			{
				let adr = response.data.data;
				for(let i=0;i<adr.length;i++)
				{
					adr[i].leaf = value.length >= 4;
				}
				return adr;
			}
		});
	};
	//地址加载
	Vue.prototype.adrtrans=function(value) {
		return value.join(",");
	};
	//登出
	Vue.prototype.logoutM=function() {
		this.logout()
		.then(()=>{
			this.$store.state.main.user={
				m_qaedas_id: 1,
				onload: true
			};
			let logout=this.getCookie(this.config.logout);
			if(logout=='')
			{
				this.$router.push("/login");
			}
			else
			{
				window.location.href=logout;
			}
		});
	};
	//长按指令
	Vue.directive('click',
	{
		bind:function (el, binding) {
			let op = el;  //当前元素
			op.onmousedown = function (e) {
				binding.value({click: 'down',num: op.id});
			}
			op.onmouseup= function (e) {
				binding.value({click: 'up',num: op.id});
			}
		}
	});
	//窗体关闭提示
	Vue.prototype.formClose=function(done)
	{
		this.$confirm('确认关闭？')
		.then(_ => {
			done();
		})
		.catch(_ => {});
	}
	//登录跳转
	Vue.prototype.loginto=function(value)
	{
		if(this.$route.path=="/login")
		{
			if(value.accountType==2)
			{
				this.setCookie(this.config.tokenTJ,value.token,3);
				this.$router.push('/hadoop');
				return;
			}
			if(value.m_qaedas_id!=0)
			{
				this.setCookie(this.config.jdid,value.m_qaedas_id,3);
				if(value.qaedasInfo.lot_system==1)
				{
					this.$router.push('/iot/terminal');
				}
				else if(value.qaedasInfo.video_system==1)
				{
					this.$router.push('/video/show');
				}
				else if(value.qaedasInfo.production_system==1)
				{
					this.$router.push('/production/record');
				}
				else
				{
					this.$router.push('/traceability/retrospect');
				}
			}
			else
			{
				this.$router.push('/main');
			}
		}
		else if(this.$route.path=="/main"||this.$route.path=="/account"||this.$route.path=="/location"||this.$route.path=="/scattergram")
		{
			if(value.m_qaedas_id!=0)
			{
				this.setCookie(this.config.jdid,value.m_qaedas_id,3);
				if(value.qaedasInfo.lot_system==1)
				{
					this.$router.push('/iot/terminal');
				}
				else if(value.qaedasInfo.video_system==1)
				{
					this.$router.push('/video/show');
				}
				else if(value.qaedasInfo.production_system==1)
				{
					this.$router.push('/production/record');
				}
				else
				{
					this.$router.push('/traceability/retrospect');
				}
			}
		}
	}
	//窗体关闭提示
	Vue.prototype.formClose=function(done)
	{
		this.$confirm('确认关闭？')
		.then(_ => {
			done();
		})
		.catch(_ => {});
	};
	//message单例显示
	Vue.prototype.message=function(value)
	{
		this.$message.closeAll();
		this.$message(value);
	};
	//value2赋值value1
	Vue.prototype.setdata=function(value1,value2) {
		for(let key in value1)
		{
			value1[key]=value2[key];
		}
	};
}
/* HTTP Status 400 （错误请求） 
->服务器不理解请求的语法。
HTTP Status 401 （未授权） 
->请求要求身份验证。 对于需要登录的网页，服务器可能返回此响应。
HTTP Status 403 （禁止）
-> 服务器拒绝请求。
HTTP Status 404 （未找到） 
->服务器找不到请求的网页。
HTTP Status 405 （方法禁用） 
->禁用请求中指定的方法。
HTTP Status 406 （不接受） 
->无法使用请求的内容特性响应请求的网页。
HTTP Status 407 （需要代理授权） 
->此状态代码与 401（未授权）类似，但指定请求者应当授权使用代理。
HTTP Status 408 （请求超时） 
->服务器等候请求时发生超时。
HTTP Status 409 （冲突） 
->服务器在完成请求时发生冲突。 服务器必须在响应中包含有关冲突的信息。
HTTP Status 410 （已删除）
-> 如果请求的资源已永久删除，服务器就会返回此响应。
HTTP Status 411 （需要有效长度） 
->服务器不接受不含有效内容长度标头字段的请求。
HTTP Status 412 （未满足前提条件） 
->服务器未满足请求者在请求中设置的其中一个前提条件。
HTTP Status 413 （请求实体过大） 
->服务器无法处理请求，因为请求实体过大，超出服务器的处理能力。
HTTP Status 414 （请求的 URI 过长） 请求的 URI（通常为网址）过长，服务器无法处理。
HTTP Status 415 （不支持的媒体类型） 
->请求的格式不受请求页面的支持。
HTTP Status 416 （请求范围不符合要求） 
->如果页面无法提供请求的范围，则服务器会返回此状态代码。
HTTP Status 417 （未满足期望值） 
->服务器未满足”期望”请求标头字段的要求。
HTTP Status 500 （服务器内部错误） 
->服务器遇到错误，无法完成请求。
HTTP Status 501 （尚未实施） 
->服务器不具备完成请求的功能。 例如，服务器无法识别请求方法时可能会返回此代码。
HTTP Status 502 （错误网关） 
->服务器作为网关或代理，从上游服务器收到无效响应。
HTTP Status 503 （服务不可用）
-> 服务器目前无法使用（由于超载或停机维护）。 通常，这只是暂时状态。
HTTP Status 504 （网关超时） 
->服务器作为网关或代理，但是没有及时从上游服务器收到请求。
HTTP Status 505 （HTTP 版本不受支持） */